<template>
	<c-form ref="form" unit-width="100%">
		<c-form-item :label="false">
			<c-drag-sort v-model="sortList" class="sort" @sort="$refs.form.setEditState(true)">
				<template #default="{item, index}">
					<c-drag-item :key="item.key" class="sort-item flex-center">
						<c-drag-handle>
							<div class="sort-drag flex-center">
								<i class="c-transfer-option-drag c-icon-sort-drag"></i>
							</div>
						</c-drag-handle>
						<c-select v-model="item.field" class="sort-field flex-grow" :options="sortField" :disable-options="disabledSortField" search :clear="false" @change="sortFieldHandle($event, item)"></c-select>
						<ul class="flex-center flex-grow sort-type">
							<li v-for="(type, i) in sortTypeName[item.type]" :key="i" class="flex-grow flex-center" :class="{'z-crt': item.sort == sortType[i]}" @click="item.sort = sortType[item.sort == sortType[0] ? 1 : 0]; $refs.form.setEditState(true);">{{type}}</li>
						</ul>
						<a class="sort-delete" @click="deleteSortHandle(item, index)"><i class="tf-trash"></i></a>
					</c-drag-item>
				</template>
				<template #append>
					<div class="sort-item sort-add flex-center-cross">
						<c-button v-show="!disabledSortField.length || disabledSortField.length < sortField.length" prepend-icon="tf-plus" :style="{'margin-left': sortList.length ? '34px' : '0'}" @click="addSortHandle">添加排序条件</c-button>
					</div>
				</template>
			</c-drag-sort>
		</c-form-item>
	</c-form>
</template>

<script>
	export default {
		data() {
			return {
				sortKey: 0,
				sortField: [],
				sortList: [],
				sortTypeName: {
					1: ['A → Z', 'Z → A'],
					2: ['0 → 9', '9 → 0'],
					3: ['从早到晚', '从晚到早'],
					4: ['正向排序', '倒向排序']
				},
				sortType: ['asc', 'desc'],
				disabledSortField: [],
			}
		},

		methods: {
			async set(workType, list = []) {
				if (!workType) return;
				this.$refs.form.setEditState(false);
				this.sortField = [];
				this.sortList = [];
				this.disabledSortField = [];
				
				await this.request({
					url: '/sys_user_view/sort_field_list',
					data: {
						work_type_id: workType
					},
					success: data => {
						this.sortField = data.map(item => {
							return {
								name: item.field_title,
								value: item.id,
								data: item
							}
						});
					}
				});

				this.sortList = list.map(item => {
					let field = this.sortField.find(temp => temp.value == item.field_id);
					if (!field) return null;
					return Object.assign(this.sortFieldHandle(field), {
						key: this.sortKey++,
						field: item.field_id,
						sort: item.sort_type
					})
				}).filter(item => item);
			},

			reset() {
				this.disabledSortField = [];
				this.sortList = [];
			},

			addSortHandle() {
				let field = this.sortField.find(item => this.disabledSortField.findIndex(value => value == item.value) == -1);
				this.sortList.push(Object.assign(this.sortFieldHandle(field), {
					key: this.sortKey++,
					field: field.value
				}));
				this.$refs.form.setEditState(true);
			},

			deleteSortHandle(item, i) {
				this.sortList.splice(i, 1);
				let index = this.disabledSortField.findIndex(value => value == item.field);
				if (index != -1) {
					this.disabledSortField.splice(index, 1);
				}
				this.$refs.form.setEditState(true);
			},

			sortFieldHandle({data: field}, item = {}) {
				let type = field.field_type == 9
					? field.config_json.type == 'formula'
						? field.config_json.value_type
						: field.config_json.type
					: field.field_type;
				this.$set(item, 'type', 
					type == 2 || type == 'number'
						? 2
						: type == 3 || type == 'time'
							? 3
							: field.config_json.dict_config && field.config_json.dict_config.dictType == 'PAGEDIC'
								? 4
								: 1
				);
				this.$set(item, 'sort', this.sortType[0]);
				this.$nextTick(() => {
					this.disabledSortField = this.sortList.map(item => item.field);
				});
				return item;
			},

			get() {
				return this.sortList.map(item => {
					return {
						field_id: item.field,
						sort_type: item.sort
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.sort {
		&-drag {
			width: 24px;
			height: 30px;
			border-radius: 4px;
			cursor: grab;

			&:hover {
				color: var(--color-main);
				background: #eee;
			}
		}

		&-field {
			width: 0;
		}

		&-type {
			gap: 2px;
			height: 34px;
			border-radius: 4px;
			padding: 0 4px;
			background: #F5F5F5;

			li {
				box-sizing: border-box;
				width: 60px;
				height: 28px;
				border: 1px solid transparent;
				border-radius: 4px;
				font-size: 13px;
				color: #444;
				cursor: pointer;

				&:hover {
					color: var(--color-main);
				}

				&.z-crt {
					border-color: #eee;
					color: var(--color-main);
					background: #fff;
				}
			}
		}

		&-delete {
			padding: 5px;
			font-size: 15px;
			color: #f00;

			&:hover {
				border-radius: 4px;
				background: #F5F5F5;
			}
		}

		&-item {
			gap: 10px;

			&:nth-child(n+2) {
				margin-top: 12px;
			}
		}
	}
</style>
